export const DIRECTORATE_LIST = [
  { label: 'DEE', value: '1' },
  { label: 'DSE', value: '2' },
  { label: 'SAMAGRA SHIKSHA', value: '3' },
  { label: 'GCC', value: '4' },
  { label: 'SCERT', value: '5' },
  { label: 'KALLAR SCHOOLS', value: '6' },
];

// Master vacancy-level list. Every role/directorate specific vacancy list is a
// subset of this, picked by `value` in planningOptions.
export const VACANCY_LEVELS_ALL = [
  { label: 'State', value: '1' },
  { label: 'CEO', value: '2' },
  { label: 'DEO (Elementary)', value: '3' },
  { label: 'DEO (Secondary)', value: '4' },
  { label: 'BEO', value: '5' },
  { label: 'EO-GCC', value: '6' },
  { label: 'DIET Prinicipal', value: '7' },
];

export const COUNSELLING_TYPES_FULL = [
  { label: 'Deployment', value: '1' },
  { label: 'Transfer', value: '2' },
  { label: 'Promotion', value: '3' },
  { label: 'New Appointment', value: '4' },
  { label: 'Hill Up', value: '5' },
  { label: 'Hill Down', value: '6' },
  { label: 'Return To Home Block', value: '7' },
  { label: 'Mutual Transfer', value: '8' },
  { label: 'Unit Transfer', value: '9' },
];

export const SCHOOL_TYPE_LIST = [
  { label: 'Government', value: '1' },
  { label: 'Fully Aided', value: '2' },
  { label: 'Un-aided', value: '3' },
  { label: 'Partially Aided', value: '4' },
  { label: 'Central Govt', value: '5' },
];

export const TYPE_LIST = [
  { label: 'Boys', value: '1' },
  { label: 'Girls', value: '2' },
  { label: 'Co-educational', value: '3' },
];

export const SCH_TYPE_CATEGORY_LIST = [
  { label: 'Pre-Primary School', value: '1' },
  { label: 'Primary School', value: '2' },
  { label: 'Middle School', value: '3' },
  { label: 'High School', value: '4' },
  { label: 'Higher Secondary School', value: '5' },
  { label: 'Others', value: '6' },
];
